import {
  Option,
  Question,
  Section,
  TestPattern,
  TestRes,
} from '../../../response/test.response';
import { CandidateResponseService } from '../../../service/candidate-response.service';
import {
  CandidateResReq,
  OptionCandidateRes,
  QuestionCandidateRes,
  SectionCandidateRes,
} from '../../../request/candidate-response.request';
import { SecurityManager } from '../../../security/security-manager';

export const useSaveResponse = () => {
  const saveTest = async (
    testRes: TestRes,
    submitted: boolean,
  ): Promise<any[]> => {
    const isNTAPattern =
      testRes.pattern == TestPattern.JEE_MAIN ||
      testRes.pattern == TestPattern.NEET ||
      testRes.pattern == TestPattern.JEE_ADVANCE ||
      testRes.pattern == TestPattern.NTA ||
      testRes.pattern == TestPattern.CHAPTER_TEST ||
      testRes.pattern == TestPattern.MHCET_MATH ||
      testRes.pattern == TestPattern.MHCET_BIOLOGY;

    const candidateResReq = {
      testId: testRes.id,
      timeTaken: Number(testRes.timeTaken.toFixed(0)),
      sectionList: testRes.sectionList.map((section: Section) => {
        return {
          id: section.id,
          timeTaken: Number(section.timeTaken.toFixed(0)),
          fullMark: section.fullMark,
          attempted: section.attempted,
          questionList: section.questionList.map((question: Question) => {
            return {
              id: question.id,
              candidateAnswer: isNTAPattern
                ? question.saved
                  ? question.candidateAnswer
                  : null
                : question.candidateAnswer,
              timeTaken: Number(question.timeTaken.toFixed(0)),
              markedForRevisit: question.markedForRevisit,
              attempted: isNTAPattern ? question.saved : question.attempted,
              optionList:
                question.optionList?.map((option: Option) => {
                  if (isNTAPattern) {
                    return {
                      id: String(option.id),
                      selected:
                        option.selected && question.saved
                          ? option.selected
                          : false,
                    } as OptionCandidateRes;
                  }
                  return {
                    id: String(option.id),
                    selected: option.selected ? option.selected : false,
                  } as OptionCandidateRes;
                }) || [],
            } as QuestionCandidateRes;
          }),
        } as SectionCandidateRes;
      }),
      attempted: true,
      submitted: submitted,
      startTime: testRes.startTime,
      endTime: new Date().getTime(),
      isStarted: testRes.isStarted,
    } as CandidateResReq;

    if (SecurityManager.getPreview() == true) {
      return [{ submitted: false }, null];
    }

    return await CandidateResponseService.save(candidateResReq);
  };

  return {
    saveTest,
  };
};
